import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row no-wrap full-width",
  style: {"gap":"4px"}
}
const _hoisted_3 = { class: "row justify-left full-width q-py-xs no-wrap" }
const _hoisted_4 = { class: "col q-py-none" }
const _hoisted_5 = {
  class: "text-h8 text-bold q-mb-none",
  style: {"margin-top":"2px"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "row justify-center no-wrap full-width" }
const _hoisted_8 = {
  class: "q-mr-xs",
  style: {"overflow-x":"hidden","max-width":"80% !important"}
}
const _hoisted_9 = { class: "row justify-center q-ma-xs" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-h8 text-bold q-mt-md" }
const _hoisted_12 = {
  key: 1,
  class: "text-h8 text-bold q-mt-md q-mb-none"
}
const _hoisted_13 = {
  key: 3,
  class: "q-my-xs"
}
const _hoisted_14 = {
  key: 5,
  class: "row justify-between no-wrap q-pa-none q-ma-none"
}
const _hoisted_15 = { class: "text-h8 text-bold q-mt-md" }
const _hoisted_16 = {
  key: 6,
  class: "text-h8 text-bold q-mt-md q-mb-none"
}
const _hoisted_17 = {
  key: 7,
  class: "text-h8 q-my-none"
}
const _hoisted_18 = {
  key: 10,
  class: "row"
}
const _hoisted_19 = { class: "text-h8 q-mt-sm q-ml-sm" }
const _hoisted_20 = { key: 13 }
const _hoisted_21 = { key: 14 }
const _hoisted_22 = { key: 17 }
const _hoisted_23 = {
  key: 18,
  class: "row justify-left q-py-none no-wrap q-my-none items-baseline"
}
const _hoisted_24 = {
  key: 19,
  class: "row justify-left q-py-none no-wrap q-my-none items-baseline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MostaSelect = _resolveComponent("MostaSelect")!
  const _component_element_options_settings_panel = _resolveComponent("element-options-settings-panel")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_enum_display_list = _resolveComponent("enum-display-list")!
  const _component_formulas_list = _resolveComponent("formulas-list")!
  const _component_recursive_selector = _resolveComponent("recursive-selector")!
  const _component_mosta_tree_select = _resolveComponent("mosta-tree-select")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_selector_popup = _resolveComponent("selector-popup")!
  const _component_variable_display_list = _resolveComponent("variable-display-list")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.theModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_MostaSelect, {
            modelValue: _ctx.widthModel,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.widthModel) = $event)),
            class: "q-mb-xs",
            style: {"flex":"1 1 0","min-width":"0"},
            options: _ctx.widthOptions
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_MostaSelect, {
            modelValue: _ctx.elementWidthModel,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.elementWidthModel) = $event)),
            class: "q-mb-xs",
            style: {"flex":"1 1 0","min-width":"0"},
            options: _ctx.elementWidthOptions
          }, null, 8, ["modelValue", "options"])
        ]),
        _withDirectives(_createVNode(_component_MostaSelect, {
          modelValue: _ctx.axisModel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.axisModel) = $event)),
          class: "q-mb-xs",
          label: _ctx.$t('path_to_file'),
          options: _ctx.axisOptions
        }, null, 8, ["modelValue", "label", "options"]), [
          [_vShow, false]
        ]),
        (_ctx.hasAnalyticElementOptions)
          ? (_openBlock(), _createBlock(_component_element_options_settings_panel, {
              key: 0,
              modelValue: _ctx.theModel.Options,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.theModel.Options) = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_btn, {
            class: "q-my-none unset-items-center",
            flat: "",
            dense: "",
            round: "",
            icon: "add",
            size: "sm",
            color: "grey-8",
            onClick: _ctx.addNewGElement,
            "aria-label": _ctx.$t('add_pie_sector')
          }, null, 8, ["onClick", "aria-label"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pie_sectors')), 1)
          ])
        ]),
        (_ctx.sectorModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectorModel, (sector, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  removable: "",
                  square: "",
                  key: sector.Id,
                  "icon-selected": "none",
                  "icon-remove": "delete",
                  selected: _ctx.selectedId === sector.Id,
                  onClick: () => { _ctx.selectedId = sector.Id; _ctx.tempName = sector.Name; },
                  style: _normalizeStyle(`background-color: ${_ctx.sector_index === index ? '#F0F0F0' : '#FFFFFF'};`),
                  "text-color": "grey-9",
                  class: "cursor-pointer full-width no-icon-chip",
                  onRemove: ($event: any) => (_ctx.deleteGElement(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(sector.Name), 1),
                      _createVNode(_component_q_btn, {
                        class: "q-my-none q-mx-xs q-pa-none",
                        flat: "",
                        dense: "",
                        color: "grey-7",
                        "aria-label": _ctx.$t('rename'),
                        icon: "edit",
                        size: "xs",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"])),
                        onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop","prevent"])),
                        onMouseup: (e) => { _ctx.renameBtnClick(index) }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            delay: 300,
                            anchor: "top middle",
                            self: "center middle"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('rename')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_menu, {
                            fit: "",
                            style: {"max-width":"400px"},
                            anchor: "bottom end",
                            self: "top middle",
                            ref_for: true,
                            ref: (el) => { _ctx.menus[index] = el }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_q_input, {
                                  autogrow: "",
                                  autofocus: "",
                                  color: "white",
                                  ref_for: true,
                                  ref: (el) => { _ctx.inputs[index] = el },
                                  debounce: "500",
                                  multiline: "",
                                  dense: "",
                                  outlined: "",
                                  "hide-bottom-space": "",
                                  modelValue: _ctx.tempName,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tempName) = $event)),
                                  "no-error-icon": "",
                                  placeholder: _ctx.$t('name'),
                                  rules: [(val) => !!val || _ctx.$t('input_name')],
                                  onKeydown: _withKeys(_withModifiers((val) => { _ctx.renameGElement(index); }, ["stop","prevent"]), ["enter"])
                                }, null, 8, ["modelValue", "placeholder", "rules", "onKeydown"]),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                      class: "q-my-none q-ml-xs q-pa-none unset-items-center",
                                      flat: "",
                                      dense: "",
                                      round: "",
                                      color: "grey-7",
                                      "bg-color": "transparent",
                                      onClick: ($event: any) => (_ctx.renameGElement(index)),
                                      "aria-label": _ctx.$t('apply_changes'),
                                      icon: "done",
                                      size: "sm"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, {
                                          delay: 300,
                                          anchor: "top middle",
                                          self: "center middle"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('apply_changes')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "aria-label"])), [
                                      [_directive_close_popup]
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1536)
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "onMouseup"]),
                      _createVNode(_component_q_space),
                      _createVNode(_component_q_btn, {
                        class: "q-my-none q-mx-xs q-pa-none",
                        flat: "",
                        dense: "",
                        color: "grey-7",
                        "aria-label": _ctx.$t('clone'),
                        icon: "content_copy",
                        size: "xs",
                        onClick: _withModifiers(($event: any) => (_ctx.cloneGElement(index)), ["stop","prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            delay: 300,
                            anchor: "top middle",
                            self: "center middle"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('clone')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["selected", "onClick", "style", "onRemove"]))
              }), 128)),
              (_ctx.sectorModel && _ctx.sectorModel.length && _ctx.sector_index >= 0 && _ctx.sector_index < _ctx.sectorModel.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('pie_settings')), 1),
                    (!_ctx.isEvaluateFormulas && !_ctx.isReportSegment)
                      ? (_openBlock(), _createBlock(_component_MostaSelect, {
                          key: 0,
                          modelValue: _ctx.sectorAnalyzedModel,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sectorAnalyzedModel) = $event)),
                          class: "q-mb-xs q-mx-none",
                          "option-label": "Name",
                          label: _ctx.$t('analyzed_element'),
                          options: _ctx.genstore.analyzedListForChart
                        }, null, 8, ["modelValue", "label", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.isPieChart)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('func_label')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isPieChart)
                      ? (_openBlock(), _createBlock(_component_enum_display_list, {
                          key: 2,
                          elements: _ctx.evaluateToList,
                          "enum-to-string": _ctx.EvaluateFunctionToStr,
                          "allow-multiple": false,
                          combobox: false,
                          "element-type": 8,
                          modelValue: _ctx.evaluateModel,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.evaluateModel) = $event))
                        }, null, 8, ["elements", "enum-to-string", "modelValue"]))
                      : _createCommentVNode("", true),
                    ((_ctx.isPieChart) && _ctx.isEvaluateFormulas && !_ctx.isReportSegment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_formulas_list, {
                            "use-chart-mode": true,
                            "parameter-options": _ctx.graphstore.getCurrentFormulas,
                            "nested-key-name": "ChildFormulas",
                            "template-name": "Entity",
                            modelValue: (_ctx.sectorModel[_ctx.sector_index] as ClientProjectSectorTypes).Formulas,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (((_ctx.sectorModel[_ctx.sector_index] as ClientProjectSectorTypes).Formulas) = $event)),
                            onChangePosition: _ctx.moveFormulaItem
                          }, null, 8, ["parameter-options", "modelValue", "onChangePosition"])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.isPieChart) && _ctx.isEvaluateParameter)
                      ? (_openBlock(), _createBlock(_component_mosta_tree_select, {
                          key: 4,
                          ref: "param_select_base",
                          "display-text": _ctx.baseParameterModelStr,
                          placeholder: _ctx.$t('select_parameter'),
                          "content-max-height": 300,
                          "onUpdate:search": _cache[11] || (_cache[11] = (val) => { _ctx.filter_string = val; }),
                          onKeyDown: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$refs.rec_selector_base && _ctx.$refs.rec_selector_base.trackArrowDown(1))),
                          onKeyUp: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$refs.rec_selector_base && _ctx.$refs.rec_selector_base.trackArrowUp(1))),
                          onKeyEnter: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$refs.rec_selector_base && _ctx.$refs.rec_selector_base.selectCurrent()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_recursive_selector, {
                              ref: "rec_selector_base",
                              elements: (_ctx.theModel as ClientProjectPieTypes).Parameters,
                              "take-ids-only": true,
                              "allow-multiple": false,
                              "element-type": 1,
                              modelValue: _ctx.baseParameterModel,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.baseParameterModel) = $event)),
                              "parameter-type-name": "Type",
                              "filter-out-list": [3,6,7],
                              "return-type": "chain",
                              "nested-key-name": _ctx.NestedKeyName,
                              "filter-string": _ctx.filter_string
                            }, null, 8, ["elements", "modelValue", "nested-key-name", "filter-string"])
                          ]),
                          _: 1
                        }, 8, ["display-text", "placeholder"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_mosta_checkbox, {
                            class: "q-my-xs",
                            modelValue: _ctx.sectorModel[_ctx.sector_index].DoRoundParts,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sectorModel[_ctx.sector_index].DoRoundParts) = $event)),
                            label: _ctx.$t('do_round')
                          }, null, 8, ["modelValue", "label"]),
                          (_ctx.sectorModel[_ctx.sector_index].DoRoundParts)
                            ? (_openBlock(), _createBlock(_component_q_input, {
                                key: 0,
                                class: "q-pa-none q-my-xs q-ml-md thin-input",
                                modelValue: _ctx.sectorModel[_ctx.sector_index].MaxSeparatePartsCount,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sectorModel[_ctx.sector_index].MaxSeparatePartsCount) = $event)),
                                outlined: "",
                                dense: "",
                                square: "",
                                "no-error-icon": "",
                                debounce: "500",
                                "hide-bottom-space": ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('sorting')), 1),
                    _createVNode(_component_enum_display_list, {
                      elements: _ctx.orderingTypeToList,
                      "enum-to-string": _ctx.orderingTypeToStr,
                      "allow-multiple": false,
                      combobox: false,
                      "element-type": 8,
                      modelValue: _ctx.orderingModel,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.orderingModel) = $event))
                    }, null, 8, ["elements", "enum-to-string", "modelValue"]),
                    (!_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('functions')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.isEvaluateFormulas && _ctx.genstore.selectedItem.DestType === 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('users_upcase')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_enum_display_list, {
                          key: 8,
                          elements: _ctx.splitFunctionToList,
                          "enum-to-string": _ctx.splitFunctionToStr,
                          "allow-multiple": false,
                          combobox: false,
                          "element-type": 8,
                          modelValue: _ctx.sectorSplitModel,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.sectorSplitModel) = $event))
                        }, null, 8, ["elements", "enum-to-string", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSplitTypeParameter && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_mosta_tree_select, {
                          key: 9,
                          ref: "param_select_split",
                          "display-text": _ctx.sectorParameterModelStr,
                          placeholder: _ctx.$t('select_parameter'),
                          "content-max-height": 300,
                          "onUpdate:search": _cache[20] || (_cache[20] = (val) => { _ctx.filter_string = val; }),
                          onKeyDown: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$refs.rec_selector_split && _ctx.$refs.rec_selector_split.trackArrowDown(1))),
                          onKeyUp: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$refs.rec_selector_split && _ctx.$refs.rec_selector_split.trackArrowUp(1))),
                          onKeyEnter: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$refs.rec_selector_split && _ctx.$refs.rec_selector_split.selectCurrent()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_recursive_selector, {
                              ref: "rec_selector_split",
                              elements: (_ctx.theModel as ClientProjectPieTypes).Parameters,
                              "take-ids-only": true,
                              "allow-multiple": false,
                              "element-type": 1,
                              modelValue: _ctx.sectorParameterModel,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.sectorParameterModel) = $event)),
                              "return-type": "chain",
                              "nested-key-name": _ctx.NestedKeyName,
                              "filter-string": _ctx.filter_string
                            }, null, 8, ["elements", "modelValue", "nested-key-name", "filter-string"])
                          ]),
                          _: 1
                        }, 8, ["display-text", "placeholder"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSplitTypeTags && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_q_btn, {
                            ref: "tagSelectorTriggerBtn",
                            class: "q-my-none q-pa-none text-left text-md",
                            flat: "",
                            "no-caps": "",
                            align: "left",
                            size: "md",
                            color: "grey-8",
                            icon: "add",
                            "aria-label": _ctx.$t('choose_tags'),
                            onClick: _ctx.openTagSelectorMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tooltip, {
                                delay: 300,
                                anchor: "top middle",
                                self: "center middle"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('choose_tags')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["aria-label", "onClick"]),
                          _createVNode(_component_selector_popup, {
                            visible: _ctx.isTagSelectorMenuVisible,
                            "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.isTagSelectorMenuVisible) = $event)),
                            "trigger-el": _ctx.$refs.tagSelectorTriggerBtn,
                            "default-width": 300
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_aux_selector, {
                                key: _ctx.tagSelectorKey,
                                "filter-model-value": _ctx.filter_string,
                                "onUpdate:filterModelValue": _ctx.onTagFilterUpdate,
                                onSelectorClosed: _ctx.closeTagSelectorMenu,
                                "model-type": 1,
                                "limit-height-to-container": true,
                                "allow-multiple": true,
                                modelValue: _ctx.sectorTagModelForAux,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.sectorTagModelForAux) = $event))
                              }, null, 8, ["filter-model-value", "onUpdate:filterModelValue", "onSelectorClosed", "modelValue"]))
                            ]),
                            _: 1
                          }, 8, ["visible", "trigger-el"]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('tags')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isSplitTypeTags && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_variable_display_list, {
                          key: 11,
                          class: "q-mb-sm",
                          modelValue: _ctx.sectorTagModel,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.sectorTagModel) = $event)),
                          onItemDeleted: _ctx.deleteTag,
                          modelType: 1,
                          modelCategory: 1
                        }, null, 8, ["modelValue", "onItemDeleted"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSplitTypeRoles && ![7, 10, 13].includes(_ctx.theModel?.Descriptor || 0) && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 12,
                          flat: "",
                          modelValue: _ctx.sectorRolesModel,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.sectorRolesModel) = $event)),
                          class: "q-mb-xs",
                          "hide-bottom-space": "",
                          "fill-input": "",
                          multiple: "",
                          outlined: "",
                          "option-value": "Id",
                          "option-label": "Name",
                          "bottom-slots": false,
                          dense: "",
                          "input-debounce": "500",
                          label: "",
                          ref: "roles_select",
                          options: (_ctx.theModel as any).WorkerRoles
                        }, {
                          "no-option": _withCtx(() => [
                            _createVNode(_component_q_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : (_ctx.isSplitTypeRoles && [10, 13].includes(_ctx.theModel?.Descriptor || 0) && !_ctx.isEvaluateFormulas)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_q_select, {
                              flat: "",
                              modelValue: _ctx.workerRoleModelPersonFile,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.workerRoleModelPersonFile) = $event)),
                              "hide-bottom-space": "",
                              multiple: "",
                              "bottom-slots": false,
                              dense: "",
                              outlined: "",
                              clearable: "",
                              "input-debounce": "500",
                              label: _ctx.$t('filter_empty'),
                              ref: "w_rolespf_select",
                              "hide-dropdown-icon": false,
                              options: _ctx.workerRoleOptionsPersonFile
                            }, {
                              "no-option": _withCtx(() => [
                                _createVNode(_component_q_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "label", "options"])
                          ]))
                        : (_ctx.isSplitTypeRoles && _ctx.theModel?.Descriptor === 7 && !_ctx.isEvaluateFormulas)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_q_select, {
                                flat: "",
                                modelValue: _ctx.workerRoleModelJob,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.workerRoleModelJob) = $event)),
                                "hide-bottom-space": "",
                                multiple: "",
                                "bottom-slots": false,
                                dense: "",
                                outlined: "",
                                clearable: "",
                                "input-debounce": "500",
                                label: _ctx.$t('filter_empty'),
                                ref: "w_rolespf_select",
                                "hide-dropdown-icon": false,
                                options: _ctx.workerRoleOptionsJob
                              }, {
                                "no-option": _withCtx(() => [
                                  _createVNode(_component_q_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "label", "options"])
                            ]))
                          : _createCommentVNode("", true),
                    (_ctx.isSplitTypeAddressInRole && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_MostaSelect, {
                          key: 15,
                          modelValue: _ctx.sectorClientRolesModel,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.sectorClientRolesModel) = $event)),
                          class: "q-mb-xs",
                          "option-label": "Name",
                          label: _ctx.$t('clinet_role'),
                          options: (_ctx.theModel as any).ClientRoles
                        }, null, 8, ["modelValue", "label", "options"]))
                      : _createCommentVNode("", true),
                    ((_ctx.isSplitTypeAddressInRole || _ctx.isSplitTypeAddress) && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_MostaSelect, {
                          key: 16,
                          modelValue: _ctx.sectorAddressLevelsModel,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.sectorAddressLevelsModel) = $event)),
                          class: "q-mb-xs",
                          "option-label": "Name",
                          label: _ctx.$t('address_levels'),
                          options: (_ctx.theModel as any).AddressLevels
                        }, null, 8, ["modelValue", "label", "options"]))
                      : _createCommentVNode("", true),
                    (_ctx.isSplitTypeJobStatus && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_q_select, {
                            flat: "",
                            modelValue: _ctx.jobStatusModel,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.jobStatusModel) = $event)),
                            class: "no-select-border q-mb-xs",
                            "hide-bottom-space": "",
                            multiple: "",
                            "bottom-slots": false,
                            dense: "",
                            outlined: "",
                            "input-debounce": "500",
                            label: !_ctx.jobStatusModel || !_ctx.jobStatusModel.length ? _ctx.$t('filter_empty') : '',
                            ref: "job_status_select",
                            "hide-dropdown-icon": false,
                            options: _ctx.jobStatusOptions
                          }, {
                            "no-option": _withCtx(() => [
                              _createVNode(_component_q_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "label", "options"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.splitHasNumberBorders)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-no-wrap q-mt-sm" }, _toDisplayString('0 < '), -1)),
                          _createVNode(_component_q_select, {
                            outlined: "",
                            dense: "",
                            disable: _ctx.graphstore.isSaving,
                            ref: "num_borders",
                            modelValue: _ctx.sectorBorderModel,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.sectorBorderModel) = $event)),
                            "use-input": "",
                            "use-chips": "",
                            multiple: "",
                            class: "q-mx-sm",
                            "hide-dropdown-icon": "",
                            "input-debounce": "500",
                            onNewValue: _ctx.addBorder,
                            placeholder: _ctx.sectorBorderModel.length ? '' : _ctx.$t('borders')
                          }, null, 8, ["disable", "modelValue", "onNewValue", "placeholder"]),
                          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-no-wrap q-mt-sm" }, _toDisplayString(' <'), -1))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isSplitTypeProjects && !_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-no-wrap q-mt-sm" }, _toDisplayString('0 < '), -1)),
                          _createVNode(_component_q_select, {
                            disable: _ctx.graphstore.isSaving,
                            outlined: "",
                            dense: "",
                            ref: "num_pcount_borders",
                            modelValue: _ctx.sectorPCountBorderModel,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.sectorPCountBorderModel) = $event)),
                            class: "q-mx-sm",
                            "use-input": "",
                            "use-chips": "",
                            multiple: "",
                            "hide-dropdown-icon": "",
                            "input-debounce": "500",
                            onNewValue: _ctx.addPCountBorder,
                            placeholder: _ctx.sectorPCountBorderModel.length ? '' : _ctx.$t('participation_borders')
                          }, null, 8, ["disable", "modelValue", "onNewValue", "placeholder"]),
                          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-no-wrap q-mt-sm" }, _toDisplayString(' <'), -1))
                        ]))
                      : _createCommentVNode("", true),
                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "q-ma-lg" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}